// @flow
import * as React from 'react';

import Experience from 'app/common/react/components/experiences/Experience/Experience';
import Toast from 'app/common/react/ui/Toast';
import withContextLog, { type ContextLog } from 'app/common/lib/react/deprecated/withContextLog'; // eslint-disable-line pinterest/no-deprecated-imports

type ExperienceToastProps =
  | {
      completionOnDismissal?: boolean,
      linkUrl?: string,
      onHide: Function,
      onClick?: Function,
      placementId: number,
      objectId?: string,
      contextLog: ContextLog,
      shouldLogClicks: true,
      thriftComponentType: string,
      thriftElementType: string,
    }
  | {
      completionOnDismissal?: boolean,
      linkUrl?: string,
      onHide: Function,
      onClick?: Function,
      placementId: number,
      objectId?: string,
      contextLog: ContextLog,
      shouldLogClicks: false,
    };

const ExperienceToast = (props: ExperienceToastProps) => (
  <Experience placementId={props.placementId} type={PCONST.thrift.ExperienceType.TOAST}>
    {({ complete, dismiss, display_data }) => {
      const finalLinkUrl = display_data.link || props.linkUrl;

      const logClick = () => {
        if (props.shouldLogClicks) {
          props.contextLog(PCONST.thrift.EventType.CLICK, {
            objectId: props.objectId,
            component: props.thriftComponentType,
            element: props.thriftElementType,
          });
        }
      };

      const onClickToast = () => {
        complete();
        if (props.onClick) {
          props.onClick();
        }
        if (props.shouldLogClicks) {
          logClick();
        }
      };

      const onHideToast = () => {
        props.onHide();
        if (props.completionOnDismissal) {
          complete();
        } else {
          dismiss();
        }
      };

      return (
        <Toast
          duration={display_data.duration}
          href={finalLinkUrl}
          text={display_data.text}
          onClick={onClickToast}
          onHide={onHideToast}
        />
      );
    }}
  </Experience>
);

export default withContextLog(ExperienceToast);
